import React, { useState } from 'react'

// Modal component
const AddServiceModal = ({ isOpen, onClose, onSave }) => {
  const [form, setForm] = useState({ name: '', regex: '' });

  if (!isOpen) return null;

  const handleSave = () => {
    if (!form.name.trim() || !form.regex.trim()) {
      Toast.error('Service name and regex are required.');
      return;
    }
    onSave(form);
    setForm({ name: '', regex: '' });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 p-6 z-10">
        <h3 className="text-lg font-bold text-[#17171C] mb-6">Add a new service</h3>

        <div className="space-y-4 mb-6">
          {/* Service Name */}
          <div>
            <label className="block text-sm font-medium text-[#17171C] mb-1">Service Name</label>
            <input
              type="text"
              value={form.name}
              onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
              className="w-full border-0 border-b border-[#E4E4E7] px-0 py-2 text-sm outline-none focus:border-[#7C3BED] bg-transparent"
              placeholder="e.g. Google Analytics"
            />
          </div>

          {/* ReGex */}
          <div>
            <label className="block text-sm font-medium text-[#17171C] mb-1">ReGex</label>
            <input
              type="text"
              value={form.regex}
              onChange={(e) => setForm((p) => ({ ...p, regex: e.target.value }))}
              className="w-full border-0 border-b border-[#E4E4E7] px-0 py-2 text-sm font-mono outline-none focus:border-[#7C3BED] bg-transparent"
              placeholder="e.g. google-analytics\\.com\\/analytics\\.js"
            />
          </div>

          {/* Caution notice */}
          <div className="bg-[#FFFBEB] border border-[#FDE68A] rounded-xl p-4">
            <p className="text-sm text-[#92400E]">
              Caution! You may run into issues if you aren't sure about the process and make sure
              to test the settings on a test environment before going live.
            </p>
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-5 py-2 cursor-pointer text-sm font-semibold text-[#6F6F7B] border border-[#E4E4E7] rounded-lg hover:bg-gray-50 transition"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSave}
            className="px-5 py-2 cursor-pointer text-sm font-semibold text-white bg-[#7C3BED] rounded-lg hover:bg-indigo-700 transition"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddServiceModal
